import styled from '@emotion/styled'

import { MessageBox, onDownloadLinkClick, Space } from '../..'
import Icon from '../../atoms/Icon'

const StyledDownloadLinksWrapper = styled.div`
  display: grid;
  grid-template-columns: 50% 50%;
  grid-column-gap: 24px;
  grid-row-gap: 24px;
  button {
    color: var(--Red-Dark);
    text-decoration: underline;
    &:hover {
      color: var(--Graphite);
      text-decoration: none;
      cursor: pointer;
    }
  }
`

export type TradeDocumentsProps = {
  tradeDocumentationUrl: string
}

const TradeDocumentDownloadButton = ({
  children,
  url
}: {
  children: React.ReactNode
  url: string
}) => (
  <button
    type="button"
    onClick={() =>
      onDownloadLinkClick({
        url
      })
    }
  >
    <Space isflex alignItems="center">
      <Space mr={1}>
        <Icon name="document" size="medium" />
      </Space>
      <Space>{children}</Space>
    </Space>
  </button>
)

const TradeDocuments = ({ tradeDocumentationUrl }: TradeDocumentsProps) => (
  <MessageBox state="documents">
    <StyledDownloadLinksWrapper>
      <TradeDocumentDownloadButton url="/api/absa/documentation/CustomisedNoteAPS.pdf">
        Note applicable pricing supplement
      </TradeDocumentDownloadButton>
      <TradeDocumentDownloadButton url="/api/absa/documentation/AbsaPlatformTCs.pdf">
        Platform terms and conditions
      </TradeDocumentDownloadButton>
      <TradeDocumentDownloadButton url={`/api/absa${tradeDocumentationUrl}`}>
        Trade confirmation
      </TradeDocumentDownloadButton>
      <TradeDocumentDownloadButton url="/api/absa/documentation/CustomisedNoteTerms.pdf">
        Absa structure note programme
      </TradeDocumentDownloadButton>
    </StyledDownloadLinksWrapper>
  </MessageBox>
)

export default TradeDocuments
